module.exports = require('./lib/schema-inspector');



//////////////////
// WEBPACK FOOTER
// ./node_modules/schema-inspector/index.js
// module id = KbmW
// module chunks = 6